export default __webpack_public_path__ + "static/media/Bot-Work-In-Progress-4.2d3aa861.jpg";